import React from 'react';

function isSystemEntityRoute() {
  const p = window.location.pathname;
  // Handles /catalog/<ns>/system/<name>
  return p.includes('/catalog/') && p.includes('/system/');
}

function getMainContainer(): HTMLElement {
  return (
    (document.querySelector('main') as HTMLElement | null) ||
    (document.querySelector('[role="main"]') as HTMLElement | null) ||
    document.body
  );
}

function hideSystemEntityBanner() {
  const root = getMainContainer();

  // Hide Backstage page header(s) inside the main content area only
  const headers = root.querySelectorAll<HTMLElement>(
    '.BackstagePageHeader-root, .BackstagePageHeader-header, [data-testid="page-header"], [data-testid="entity-page-header"]',
  );

  headers.forEach(el => {
    el.style.setProperty('display', 'none', 'important');
    el.style.setProperty('visibility', 'hidden', 'important');
    el.style.setProperty('height', '0px', 'important');
    el.style.setProperty('padding', '0px', 'important');
    el.style.setProperty('margin', '0px', 'important');
  });

  // Also hide the "..." menu button wherever it is
  document
    .querySelectorAll<HTMLButtonElement>(
      'button[data-testid="menu-button"][aria-label="more"]',
    )
    .forEach(btn => {
      btn.style.setProperty('display', 'none', 'important');
      btn.style.setProperty('visibility', 'hidden', 'important');
    });
}

function hideSystemChrome() {
  /* Hide the "..." menu */
  document
    .querySelectorAll<HTMLButtonElement>(
      'button[data-testid="menu-button"][aria-label="more"]',
    )
    .forEach(btn => {
      btn.style.setProperty('display', 'none', 'important');
      btn.style.setProperty('visibility', 'hidden', 'important');
    });

  /* Hide Owner rows (About card, header metadata, etc.) */
  document
    .querySelectorAll<HTMLElement>(
      // Matches labels or text nodes containing "Owner"
      'span, div, dt, th, td',
    )
    .forEach(el => {
      if (el.textContent?.trim() === 'Owner') {
        // Hide the label and its immediate value container
        el.style.setProperty('display', 'none', 'important');

        const value =
          el.nextElementSibling ??
          el.parentElement?.querySelector(':scope > *:nth-child(2)');

        if (value instanceof HTMLElement) {
          value.style.setProperty('display', 'none', 'important');
        }
      }
    });
}
function hideSystemTypeLabel() {
  const header = document.querySelector<HTMLElement>(
    'header[class*="BackstageHeader-header"]',
  );
  if (!header) return;

  header
    .querySelectorAll<HTMLElement>('p[class*="BackstageHeader-type"]')
    .forEach(el => {
      el.style.setProperty('display', 'none', 'important');
      el.style.setProperty('visibility', 'hidden', 'important');
    });
}
function hideOwnerInBanner() {
  // Find the header
  const header = document.querySelector<HTMLElement>('header[class*="BackstageHeader-header"]');
  if (!header) return;

  // Hide any header label group where the label text is exactly "Owner"
  const labelGroups = header.querySelectorAll<HTMLElement>('span[class*="BackstageHeaderLabel-root"]');

  labelGroups.forEach(group => {
    const label = group.querySelector('p[class*="BackstageHeaderLabel-label"]');
    if (label?.textContent?.trim() === 'Owner') {
      group.style.setProperty('display', 'none', 'important');
      group.style.setProperty('visibility', 'hidden', 'important');
    }
  });
}

function hideFavoritesStar() {
  const header = document.querySelector<HTMLElement>(
    'header[class*="BackstageHeader-header"]',
  );
  if (!header) return;

  header
    .querySelectorAll<HTMLButtonElement>(
      'button[aria-label="Add to favorites"], button[aria-label="Remove from favorites"]',
    )
    .forEach(btn => {
      btn.style.setProperty('display', 'none', 'important');
      btn.style.setProperty('visibility', 'hidden', 'important');
    });
}

export const HideSystemEntityChrome = () => {
  React.useEffect(() => {
    const apply = () => {
      if (!isSystemEntityRoute()) return;
      hideSystemTypeLabel();
      hideFavoritesStar();
      hideSystemChrome();
      hideOwnerInBanner();
    };

    // Run once now
    apply();

    // Keep enforcing as Backstage re-renders/remounts
    const obs = new MutationObserver(apply);
    obs.observe(document.body, { childList: true, subtree: true });

    return () => obs.disconnect();
  }, []);

  return null;
};



// import React from 'react';

// function hideSystemChrome() {
//   /* Hide the "..." menu */
//   document
//     .querySelectorAll<HTMLButtonElement>(
//       'button[data-testid="menu-button"][aria-label="more"]',
//     )
//     .forEach(btn => {
//       btn.style.setProperty('display', 'none', 'important');
//       btn.style.setProperty('visibility', 'hidden', 'important');
//     });

//   /* Hide Owner rows (About card, header metadata, etc.) */
//   document
//     .querySelectorAll<HTMLElement>(
//       // Matches labels or text nodes containing "Owner"
//       'span, div, dt, th, td',
//     )
//     .forEach(el => {
//       if (el.textContent?.trim() === 'Owner') {
//         // Hide the label and its immediate value container
//         el.style.setProperty('display', 'none', 'important');

//         const value =
//           el.nextElementSibling ??
//           el.parentElement?.querySelector(':scope > *:nth-child(2)');

//         if (value instanceof HTMLElement) {
//           value.style.setProperty('display', 'none', 'important');
//         }
//       }
//     });
// }

// export const HideSystemEntityChrome = () => {
//   React.useEffect(() => {
//     const isSystemEntityRoute =
//       window.location.pathname.includes('/catalog/') &&
//       window.location.pathname.includes('/system/');

//     if (!isSystemEntityRoute) return;

//     // Initial pass
//     hideSystemChrome();

//     // Keep enforcing it (Backstage re-renders a lot)
//     const obs = new MutationObserver(() => {
//       const stillSystem =
//         window.location.pathname.includes('/catalog/') &&
//         window.location.pathname.includes('/system/');

//       if (stillSystem) hideSystemChrome();
//     });

//     obs.observe(document.body, { childList: true, subtree: true });

//     return () => obs.disconnect();
//   }, []);

//   return null;
// };
